/*
  Workspace
  The main workspace area of the form builder
*/
import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

import { DocumentService, EditorState, FormService } from '@app/shared/services';
import { DocumentFieldDeletionStatus, FormBuilderDocument } from '@app/shared/services/document.model';
import { MapperComponent } from '@app/shared/components/mapper/mapper.component';
import { MessageBoxType } from '@component/message-box';

@Component({
  exportAs: 'fl-document-viewer',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'flex-cell-10' },
  selector: 'fl-document-viewer',
  styleUrls: ['./document-viewer.component.scss'],
  templateUrl: './document-viewer.component.html'
})
export class DocumentViewerComponent implements OnInit {
  @Input() document: FormBuilderDocument;
  @Input() renderPageObjects = false;
  @ViewChildren(MapperComponent) mappers!: QueryList<MapperComponent>;

  DocumentFieldDeletionStatus = DocumentFieldDeletionStatus;
  messageBoxType = MessageBoxType;

  constructor(
    public state: EditorState,
    public documentService: DocumentService,
    public formService: FormService
  ) {}

  ngOnInit() { }

  loadMapper(image: HTMLImageElement, mapper: MapperComponent): void {
    if (this.renderPageObjects && mapper) {
      mapper.init(image.width, image.height);
    }
  }

  clearMapperSelection(): void {
    this.mappers.forEach((mapper) => {
      mapper.deselectAll();
    });
  }
}
